import React, { useState } from "react";
import { Formik, Form } from "formik";
import {
  Button,
  Container,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import moment from "moment";
import { injectIntl } from "react-intl";

import docCookies from "../../docCookies";
import { history } from "../../history";
import styles from "./styles";
import PopupModal from "../../common/elements/PopupModal";
import messages from './messages'

const COOKIE_EXPIRY_TIME =  moment().add('days', 7).toDate() // one week

const initialValues = {
  password: '',
  username: '',
}


const LoginForm = props => {
  const {
    classes,
    intl: { formatMessage },
    setFormToDisplay
  } = props;
  const [authenticationFailed, setAuthenticationFailed] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [failedLoginMessage, setFailedLoginMessage] = useState("");

  const authenticateUser = values => {
    const { password, username } = values;
    let authToken;
    axios
      .post("/api/v2/authenticate", { username, password })
      .then(({ data }) => {
        authToken = `JWT ${data.auth_token}`;
        const requestConfig = {
          headers: { Authorization: authToken }
        };
        return axios.get("/api/v3/identity", requestConfig);
      })
      .then(({ data }) => {
        if (data.roles.business_admin) {
          docCookies.setItem('jwt', authToken, COOKIE_EXPIRY_TIME)
          docCookies.setItem('username', username, COOKIE_EXPIRY_TIME)
          docCookies.setItem('user_id', data.roles.staff.staff_id, COOKIE_EXPIRY_TIME)
          history.push('/home')
        } else {
          setFailedLoginMessage(formatMessage(messages.incorrectRole))
          setAuthenticationFailed(true)
        }
      })
      .catch(() => {
        setFailedLoginMessage(formatMessage(messages.failedLogin))
        setAuthenticationFailed(true)
      })
  }

  const closePopupModal = () => setAuthenticationFailed(false);

  return (
    <Formik initialValues={initialValues} onSubmit={authenticateUser}>
      {({ handleChange }) => (
        <Form>
          <Container className={classes.formContainer}>
            <Typography className={classes.displayMessage}>{formatMessage(messages.loginHeader)}</Typography>
            <TextField
              className={classes.textFields}
              label={formatMessage(messages.emailAddress)}
              name="username"
              type="email"
              onChange={handleChange}
            />
            <TextField
              className={classes.textFields}
              label={formatMessage(messages.password)}
              name="password"
              onChange={handleChange}
              type={passwordVisibility ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setPasswordVisibility(!passwordVisibility)}
                      tabIndex={-1}
                    >
                      {passwordVisibility ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <PopupModal
              message={failedLoginMessage}
              open={authenticationFailed}
              onClose={closePopupModal}
            />
          </Container>
          <Button
            className={classes.minorButton}
            color="primary"
            onClick={() => setFormToDisplay("resetPassword")}
            variant="text"
          >
            {formatMessage(messages.resetPassword)}
          </Button>
          <Button
            className={classes.majorButton}
            color="primary"
            variant="contained"
            type="submit"
          >
            {formatMessage(messages.login)}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default withStyles(styles)(injectIntl(LoginForm));
